import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const VariantBasicInfoComponent = ({ products, onInnerBasicFormChange, selectedVariants }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedVariants?.Name}
                />

                 <InputContainer
                    label="Price"
                    name="Price"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Price'

                        )
                    }}
                    type="number"
                    value={selectedVariants?.Price}
                />
                 <InputContainer
              label="Available"
              name="IsAvailable"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event,
                  'IsAvailable'
                )
              }}
              type="checkbox"
              value={selectedVariants?.IsAvailable}
          />
                <InputContainer

                    label="Product"
                    labelField="Name"
                    list={products}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'LogisticsProductId'

                        );
                    }}
                    optionName='Choose LogisticsProduct'
                    type="select"
                    value={selectedVariants?.LogisticsProductId}
                    valueField="Id"
                />
               
               <div className='col-span-full'>
        <InputContainer
        label="Description"
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'Description'
          );
        } }
        type="text"
        value={selectedVariants?.Description} /></div>
            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default VariantBasicInfoComponent;
